// extracted by mini-css-extract-plugin
module.exports = {"camp_details_wheel_box":"camp_details_wheel_box___1rT2k","wheel_list_box":"wheel_list_box___1w2BU"};